<template>
  <div class="container">
    <div
      v-show="!focused"
      class="readonly-container ellipsis cursor-text"
      :class="{ 'no-hover': disabled }"
      @click.stop="!disabled && focus()"
    >
      <span v-if="modelValue">
        <slot
          name="content"
          v-bind="{ modelValue }"
        >
          {{ modelValue }}
        </slot>
      </span>
      <span
        v-else
        class="placeholder"
      >
        <slot name="placeholder">
          {{ placeholder }}
        </slot>
      </span>

      <div v-if="$refs.input && $refs.input.dirty && $refs.input.errors">
        <span class="text-help-text text-ds-red-4">
          {{ $refs.input.errors[0] }}
        </span>
      </div>
    </div>

    <div
      v-show="focused"
      class="q-col-gutter-sm flex items-center"
      @click.stop
    >
      <slot name="beforeInput" />

      <BaseInputText
        ref="input"
        v-model="text"
        :disabled="disabled"
        :optional="optional"
        :placeholder="placeholder"
        :validations="validations"
        v-bind="$attrs"
        @blur="blur"
        @submit="submit"
      />

      <slot name="afterInput" />
    </div>
  </div>
</template>

<script>
import BaseInputText from "shared/components/base/BaseInputText.vue";

export default {
  name: "BaseInputTextInline",
  components: {
    BaseInputText,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    validations: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
    },
    optional: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue", "focus", "blur", "submit"],
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    text: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    async focus() {
      this.focused = true;
      await this.$nextTick();
      this.$refs.input.focus();
      this.$emit("focus");
    },
    blur() {
      this.focused = false;
      this.$refs.input.blur();
      this.$emit("blur");
    },
    submit() {
      if (this.$refs.input.isValid) {
        this.$emit("submit");
      }

      this.blur();
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor-text {
  cursor: text;
}

.readonly-container {
  padding: 8px;
  font-size: 14px;
  line-height: 18px;
  border: 1px solid transparent;
  user-select: none;

  &.no-hover {
    cursor: not-allowed;
  }

  &:not(.no-hover):hover {
    border: 1px solid $secondary;
    border-radius: 2px;
  }
}

.placeholder {
  color: $grey;
  user-select: none;
}

:deep(.input-wrapper) {
  background: $white;
  padding: 0;
}

:deep(input) {
  background: $white;
  border: 1px solid $grey;
  box-sizing: border-box;
  border-radius: 2px;
}
</style>
